import Button from '@mui/material/Button';
import { Filters } from '@ifa/types';

import useIsBtnClearDisabled from './hooks/useIsFiltersBtnDisabled';

type DashboardFiltersBtnClearProps = {
    clearFilters: () => void;
    filters: Filters;
};

function DashboardFiltersBtnClear({ clearFilters, filters }: DashboardFiltersBtnClearProps) {
    const isDisabled = useIsBtnClearDisabled(filters);

    return (
        <Button
            disabled={isDisabled}
            onClick={clearFilters}
            sx={{ height: '100%' }}
            fullWidth
            variant="outlined"
            data-cy="filters-clear"
        >
            Clear
        </Button>
    );
}

export default DashboardFiltersBtnClear;
